export const housekeeping = {
  // ── Page (index) ──
  title: "Sprzątanie",
  remindersBtn: "Przypomnienia",
  refresh: "Odśwież",
  aboutToLeaveTitle: "Goście, którzy dziś wyjeżdżają",
  aboutToLeaveCount: "{count} przed wyjazdem",
  remindersTitle: "Skonfiguruj przypomnienia o sprzątaniu",

  headline: {
    allDone: "Wszystko gotowe. Nic nie wymaga teraz sprzątania.",
    inProgress: "Sprzątanie w toku · {count} w trakcie",
    toClean: "Co wymaga dziś sprzątania? {count} do posprzątania",
    toCleanWithProgress: "Co wymaga dziś sprzątania? {toClean} do posprzątania · {inProgress} w trakcie",
  },

  allProperties: "Wszystkie obiekty",
  searchPlaceholder: "Szukaj pokoju, gościa…",

  // Status filter chips (label)
  chips: {
    all: "Wszystkie",
    to_clean: "Do sprzątania",
    in_progress: "W trakcie",
    occupied: "Zajęte",
    clean: "Dostępne",
    out_of_service: "Wyłączone z użytku",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "Wszystkie dzisiejsze przestrzenie, bez filtrowania.",
    to_clean: "Oczekujące na sprzątanie: oznaczone jako brudne, z dzisiejszym wyjazdem i nieposprzątane lub długie pobyty, w których minął ustalony odstęp.",
    in_progress: "Sprzątanie trwa właśnie teraz.",
    occupied: "Gość w środku (pobyt w toku, bez wyjazdu dzisiaj).",
    clean: "Posprzątane i gotowe na kolejnego gościa (łącznie ze sprawdzonymi).",
    out_of_service: "Niedostępne do sprzątania (usterka lub konserwacja).",
  },

  loadingBoard: "Wczytywanie tablicy…",
  emptyToClean: "Wszystko posprzątane. Nic nie oczekuje w tej chwili.",
  emptyStatus: "Brak przestrzeni w tym statusie.",
  emptySearch: "Żadna przestrzeń nie pasuje do wyszukiwania.",

  typeHotel: "Hotel",
  typeApartment: "Apartament",

  // Row badges
  stayDue: "Sprzątanie należne",
  hourlyStayDue: "Koniec pobytu godzinowego",
  hourlyStayAt: "Wyszedł o {time}",
  overdue: "Zaległe",
  overdueSince: "Niesprzątane od {date} · {days} dni",
  overdueGuests: "{n} gości wyjechało bez odnotowanego sprzątania",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "Od {from} do {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Po czasie",
  alreadyLeft: "Już wyjechał",
  aboutToLeave: "Przed wyjazdem",
  cleanBadge: "Posprzątane",
  inspectedBadge: "Sprawdzone",

  // Turnover (one leaves / another arrives)
  departs: "↑ Wyjazd",
  arrives: "↓ Przyjazd",
  guestFallback: "Gość",
  departsOn: "· wyjazd {date}",

  // Row actions
  assign: "Przypisz",
  reassignTitle: "Zmień osobę sprzątającą",
  assignWhoTitle: "Przypisz osobę sprzątającą",
  start: "Rozpocznij",
  startTitle: "Oznacz jako w trakcie",
  cleanAction: "Posprzątaj",
  cleanTitle: "Zakończ sprzątanie (zdjęcia i uwagi)",
  tasks: "Zadania",
  tasksTitle: "Zadania i szczegóły",

  toastSaved: "Przypomnienia o sprzątaniu zostały zaktualizowane",

  // Effective status (label)
  status: {
    to_clean: "Do sprzątania",
    in_progress: "W trakcie",
    occupied: "W użyciu",
    clean: "Dostępne",
    inspected: "Sprawdzone",
    out_of_service: "Wyłączone z użytku",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "Oczekuje na sprzątanie.",
    in_progress: "Sprzątanie w toku.",
    occupied: "W użyciu: gość w środku.",
    clean: "Posprzątane i gotowe na kolejnego gościa.",
    inspected: "Posprzątane i zweryfikowane przez przełożonego.",
    out_of_service: "Wyłączone z użytku: nie można sprzątać (usterka/konserwacja).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Wolne",
    occupied: "Zajęte",
    departure_today: "Wyjazd dzisiaj",
    arrival_today: "Przyjazd dzisiaj",
    turnover: "Wyjazd i przyjazd",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "Brak gościa: wolne.",
    occupied: "Gość w środku (pobyt w toku).",
    departure_today: "Gość wyjeżdża dzisiaj: będzie wymagać sprzątania.",
    arrival_today: "Gość przyjeżdża dzisiaj: musi być gotowe na czas.",
    turnover: "Jeden gość wyjeżdża, a drugi przyjeżdża dzisiaj: pilne sprzątanie pomiędzy nimi.",
  },

  roles: {
    limpieza: "Sprzątanie",
    mantenimiento: "Konserwacja",
    recepcion: "Recepcja",
    gestor: "Zarządca",
    propietario: "Właściciel",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Sprzątanie w trakcie pobytu należne",
    daysSince: "{count} dzień | {count} dni | {count} dni",
    interval: "codziennie | co {count} dni | co {count} dni",
    main: "Gość nadal przebywa w obiekcie. Bez sprzątania od: {since}. Sprzątanie przewidziane: {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (ok.)",
    overdue: "Przyjazd opóźniony",
    overdueTitle: "Godzina przyjazdu ({checkin}) już minęła · należy potraktować to sprzątanie priorytetowo",
    remaining: "{dur} do przyjazdu",
    remainingTitle: "Do przyjazdu ({checkin}) pozostało: {dur}",
  },

  // ── Reminders modal ──
  remind: {
    title: "Przypomnienia o sprzątaniu",
    subtitle: "Powiadamianie zespołu, gdy pokój z bliskim przyjazdem lub wyjazdem nie jest gotowy.",
    close: "Zamknij",
    scopeLabel: "Które obiekty?",
    scopeOne: "Ten obiekt",
    scopeAll: "Wszystkie",
    summary: "Przypomnienia aktywne w {enabled} z {total} obiektów.",
    propertyLabel: "Obiekt",
    activeSuffix: " · aktywne",
    propertyHelp: "Każdy obiekt ma własny harmonogram.",
    allNotePre: "Te same ustawienia zostaną zastosowane do wszystkich ",
    allNotePost: " obiektów (każdy w swoim czasie lokalnym).",
    arrivalsTitle: "Przyjazdy i wyjazdy",
    longStayTitle: "Rezerwacje długopobytowe",
    daysBeforeLabel: "Z jakim wyprzedzeniem?",
    daysBefore: {
      same: "Tylko tego samego dnia",
      upTo: "Do {count} dnia wcześniej | Do {count} dni wcześniej | Do {count} dni wcześniej",
    },
    daysBeforeHelp: "Uwzględnia przyjazdy i wyjazdy w tym oknie czasowym.",
    intervalLabel: "Co ile dni sprzątanie?",
    interval: "Codziennie | Co {count} dni | Co {count} dni",
    intervalHelp: "Liczone od ostatniego sprzątania. Pokój pojawi się w sekcji „Do sprzątania”, nawet jeśli jest nadal zajęty.",
    timeLabel: "O której są wysyłane?",
    timeHelp: "Czas lokalny obiektu. Raz dziennie.",
    recipientsLabel: "Kto otrzyma powiadomienie?",
    note: "Powiadomienia są wysyłane przez kolejkę (powiadomienie + push), a każdy alert jest zapisywany w powiadomieniach.",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    saveAll: "Zapisz dla wszystkich",
    save: "Zapisz",
    recipients: {
      assigned: "Przypisane osoby",
      team: "Zespół",
      both: "Oba",
    },
    recipientHelp: {
      assigned: "Tylko osoby przypisane do tego pokoju.",
      team: "Cały zespół sprzątający i techniczny obiektu.",
      both: "Osoby przypisane oraz zespół obiektu.",
    },
    longStayOff: "Wyłączone",
    longStaySub: "Każdego dnia pobytu | Co {count} dni pobytu | Co {count} dni pobytu",
    toggleAllOn: "Zostanie włączone dla wszystkich",
    toggleAllOff: "Zostanie wyłączone dla wszystkich",
    toggleOneOn: "Włączone dla tego obiektu",
    toggleOneOff: "Wyłączone",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Zakończ sprzątanie",
    dropStrong: "Przeciągnij tutaj zdjęcia",
    dropRest: "lub kliknij, aby wybrać",
    dropHint: "Dowód stanu pokoju · JPG, PNG, WEBP",
    photoAlt: "zdjęcie",
    saved: "Zapisano",
    view: "Zobacz",
    remove: "Usuń",
    notes: "Uwagi",
    notesPlaceholder: "Problemy, uszkodzenia, braki… (opcjonalnie)",
    cancel: "Anuluj",
    uploading: "Przesyłanie… {pct}%",
    saving: "Zapisywanie…",
    submit: "Oznacz jako posprzątane",
    previewAlt: "podgląd",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Kto sprząta tę przestrzeń?",
    allOption: "Wszyscy",
    allDesc: "Widoczne dla całego personelu sprzątającego i technicznego",
    roleSection: "Przypisz do roli",
    peopleTitle: "Albo wybierz osoby",
    peopleHint: "(jedną lub więcej)",
    emptyPre: "Brak członków zespołu. Można przypisać według roli lub dodać osoby w sekcji ",
    emptyTeam: "Zespół",
    emptyPost: ".",
    cancel: "Anuluj",
    saving: "Zapisywanie…",
    save: "Zapisz przypisanie",
  },

  // ── Planowanie: kalendarz przyszłych sprzątań ──
  plan: {
    title: "Planowanie sprzątania",
    viewToday: "Dziś",
    viewPlan: "Planowanie",
    loading: "Ładowanie kalendarza…",
    loadError: "Nie udało się wczytać kalendarza.",
    saveError: "Nie udało się zapisać. Spróbuj ponownie.",
    empty: "Brak sprzątań w tych dniach.",
    space: "Obiekt",
    prev: "Poprzednie dni",
    next: "Następne dni",
    today: "Dziś",
    days: "{n} dni",
    anyone: "Ktokolwiek",
    unassigned: "Nieprzypisane",
    headline: {
      nothing: "Nic nie czeka w tych dniach.",
      all: "{total} sprzątań w toku · {urgentes} pilnych",
      withOrphans: "{total} w toku · {urgentes} pilnych · {sin} nieprzypisanych",
    },
    types: {
      turnover: "Wyjazd i przyjazd",
      arrastre: "Zaległe",
      salida: "Wyjazd",
      estancia: "Długi pobyt",
      manual: "Oznaczone ręcznie",
    },
    abbr: { all: "WSZ", arrastre: "ZAL", turnover: "ZMIA", salida: "WYJ", estancia: "POB", manual: "RĘC" },
    windowGuessed: "Godziny domyślne: ten obiekt nie ma własnych",
    legendTight: "Mało czasu między wyjazdem a przyjazdem",
    noRoomTip: "{n} wyjazdów bez przypisanego pokoju",
    windowTip: "Między wyjazdem ({desde}) a przyjazdem ({hasta}) jest {min} minut",
    roleShort: "ROLA",
    roleFull: "Przypisane do roli, nie do osoby",
    fromSpace: "stałe przypisanie obiektu",
    nobody: "Nieprzypisane — kliknij, aby wybrać osobę",
    dow: { mon: "P", tue: "W", wed: "Ś", thu: "C", fri: "P", sat: "S", sun: "N" },

    teamRows: "Obciążenie zespołu",

    teamTitle: "Zespół",
    capacity: "Wydajność",
    capacityTitle: "Ile sprzątań dana osoba wyrabia dziennie",
    done: "Gotowe",
    perDay: "Na dzień",
    dayOffTip: "Oznacz jako dzień wolny",
    noStaff: "Nie masz jeszcze personelu sprzątającego. Dodaj osoby w Zespole, a tutaj zobaczysz ich obciążenie.",
    shortHands: "Brakuje rąk: {dias}",
    loadTip: "{dia}: {n} z {cap}",
    loadTipOff: "{dia}: dzień wolny ({n} przypisanych)",
    hasNow: "{n} przypisanych · wyrabia {cap} dziennie",

    selected: "Wybrano {n}",
    assignTo: "Przypisz do…",
    assignBtn: "Przypisz {n}",
    people: "Osoby",
    noteTitle: "Notatka do tego sprzątania",
    notePlaceholder: "Przyjeżdża późno, priorytet…",
    unassign: "Usuń",
    clear: "Odznacz",
    assigned: "Przypisano {n} sprzątań",
    unassigned2: "Przypisanie usunięte",
    partial: "Przypisano {n}, {mal} się nie udało",
    autoAssign: "Rozdziel automatycznie",
    nothingToAssign: "W tych dniach nie ma nic nieprzypisanego.",
    proposalTitle: "Propozycja podziału",
    proposalSub: "Rozdzielono {n} sprzątań. Sprawdź przed zastosowaniem.",
    proposalApply: "Zastosuj podział",
    proposalUncovered: "{n} bez obsady",
    cancel: "Anuluj",
    uncovered: {
      nadie_tiene_esta_propiedad: "nikt nie ma przypisanego tego obiektu",
      nadie_trabaja_ese_dia: "nikt nie pracuje tego dnia",
      equipo_lleno: "zespół jest na granicy",
    },
    rejected: {
      espacio_ajeno: "Ten obiekt nie należy do Twojego konta.",
      persona_ajena: "Ta osoba nie jest w Twoim zespole.",
      persona_sin_la_propiedad: "Ta osoba nie ma przypisanego tego obiektu. Najpierw przypisz go w Zespole.",
      rol_desconocido: "Taka rola nie istnieje.",
      datos_incompletos: "Brakuje danych sprzątania.",
      error_al_guardar: "Nie udało się zapisać.",
    },
    autoAssignN: "Rozdziel {n}",
    seeDay: "Zobacz dzień",
    filtering: "Filtrowanie wg",
    showingOf: "widać {n} z {total}",
    emptyFiltered: "Brak wyników dla tych filtrów. W tych dniach jest {total} sprzątań.",
    moreFilters: "Więcej filtrów",
    roomy: "Wygodnie",
    dense: "Kompaktowo",
    ofN: "z {n} sprzątań",
    addPerson: "Dodaj kogoś do zespołu",
    notCleaner: "To nie personel sprzątający, ale ma przypisaną pracę",
    teamCap: "{n} dziennie",
    teamFoot: "Obciążenie dotyczy całego zakresu; filtry go nie zmieniają.",
    perDayN: "{n} dziennie",
    closedN: "{n} zamkniętych",
    capMax: "Maksimum to {n} dziennie",
    rowHint: "Alt + kliknięcie wybiera cały wiersz",
    daySheetTip: "Kliknij, aby zobaczyć dzień · Alt + kliknięcie wybiera go w całości",
    keysHint: "1-9 przypisuje · A otwiera · Esc czyści",
    undo: "Cofnij",
    undone: "Przywrócono podział",
    tightDay: "{dia} ma {n} sprzątań",
    tightMore1: "i jeszcze 1 dzień",
    tightMoreN: "i jeszcze {n} dni",
    proposalDetail: "Zobacz podział sprzątanie po sprzątaniu",
    nobody2: "Jeszcze nikt",
    warnDayOff: "{quien} ma wolne w {dia}.",
    warnOver: "{quien} dochodzi do {n} w {dia}, a wyrabia {cap}.",
    onDay: "{dia}: {n} + {mas} z {cap}",
    onDays: "{dias} dni: {n} z {cap}",
    c: { pending: "W toku", urgent: "Pilne", tight: "Napięte dni", done: "Zrobione", noRoom: "Bez pokoju" },
    rows: {
      withWork: "z pracą",
      all: "wszystkie",
      help: "„Wszystkie\" pokazują też obiekty, których w tych dniach nie trzeba sprzątać.",
      forced: "Przy aktywnym filtrze pokazywane są tylko obiekty z pracą.",
    },
    f: {
      any: "Dowolne",
      urgency: "Pilność",
      window: "Okno",
      state: "Stan",
      unitType: "Rodzaj obiektu",
      clear: "Wyczyść filtry",
    },
    urg: {
      urgente: "Tego dnia ktoś przyjeżdża",
      alta: "Przyjeżdża następnego dnia",
      normal: "Przyjeżdża za 2-3 dni",
      baja: "Nikt potem nie przyjeżdża",
    },
    holg: { amplia: "Luźne", justa: "Napięte", imposible: "Nie starczy czasu" },
    estados: {
      pendiente: "W toku",
      en_curso: "W trakcie",
      hecha: "Zrobione",
      fuera_de_servicio: "Wyłączone z użytku",
    },
    motivos: {
      faltan_manos: "brakuje rąk do {n}",
      con_hora_limite: "{n} z terminem",
      varios_edificios: "{n} różnych budynków",
    },
    sheet: {
      autoDay: "Rozdziel ten dzień",
      assignAll: "Przypisz wszystkie ({n})",
      nCleanings: "{n} sprzątań",
      nUnassigned: "{n} nieprzypisanych",
      covers: "zespół pokrywa {n}",
      empty: "Tego dnia nie ma nic do sprzątania.",
    },
    tip: {
      outIn: "wyjazd · przyjazd",
      lateSold: "sprzedany późny wyjazd",
      earlySold: "wcześniejszy przyjazd",
      noName: "Bez nazwiska",
      pax: "{n} os.",
      nights: "{n} nocy",
      min: "{n} min",
      h: "{h} godz.",
      hm: "{h} godz. {m}",
      stillIn: "nadal mieszka",
      freeNobody: "zostaje wolny",
      freeNone: "ktoś przyjeżdża",
      freeDay1: "wolny 1 dzień",
      freeDaysN: "wolny {n} dni",
      houseHours: "godziny domyślne",
      openSpace: "Karta obiektu", openSpaceHint: "Otwiera się w tablicy Dziś, ze stanem, zadaniami i historią",
      select: "Wybierz",
      deselect: "Usuń z wyboru",
      assignedBy: "Przypisał(a) {quien}",
    },
  },
};
